'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _button = require('../button');

var _button2 = _interopRequireDefault(_button);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _openShareDialog = require('./openShareDialog');

var _openShareDialog2 = _interopRequireDefault(_openShareDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Uses the Button component to create a share button with an icon. Renamed from `ButtonSocial` in v2.1
 *
 * Will accept any props that the Button accepts
 */
var ButtonShare = function ButtonShare(_ref) {
  var share = _ref.share,
      type = _ref.type,
      url = _ref.url,
      title = _ref.title,
      hashtags = _ref.hashtags,
      image = _ref.image,
      props = _objectWithoutProperties(_ref, ['share', 'type', 'url', 'title', 'hashtags', 'image']);

  return _react2.default.createElement(
    _button2.default,
    _extends({
      background: type,
      tag: share ? 'button' : 'a',
      onClick: share && (0, _openShareDialog2.default)({ type: type, url: url, title: title, hashtags: hashtags, image: image }),
      'aria-label': type
    }, props),
    _react2.default.createElement(_icon2.default, { name: type })
  );
};

ButtonShare.propTypes = {
  /**
   * The social network / share target
   */
  type: _propTypes2.default.oneOf(['facebook', 'fitbit', 'google', 'instagram', 'linkedin', 'mail', 'mapmyfitness', 'messenger', 'pinterest', 'reddit', 'slack', 'sms', 'strava', 'twitter', 'vimeo', 'whatsapp', 'youtube']).isRequired,

  /**
   * Makes the button a share button (only available for twitter, facebook, linkedin, pinterest & mail)
   */
  share: _propTypes2.default.bool,

  /**
   * Hashtags to be added to a twitter share
   */
  hashtags: _propTypes2.default.string,

  /**
   * The text for a twitter, linkedin or pinterest share. Also the email subject for mail share
   */
  title: _propTypes2.default.string
};

ButtonShare.defaultProps = {
  spacing: 0.5,
  effect: 'grow',
  radius: 'large',
  target: '_blank'
};

exports.default = ButtonShare;


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/button-share/index.js
// module id = 266
// module chunks = 0